import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

interface Breadcrumb {
	label: string;
	url: string;
}

@Component({
  standalone: false,
	selector: 'app-breadcrumbs',
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './app-breadcrumb.component.html',
})
export class AppBreadcrumbsComponent implements OnInit, OnDestroy {
	breadcrumbs: Array<Breadcrumb> = [];
	private routerSubscription: Subscription | undefined;

	constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

	ngOnInit(): void {
		this.routerSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
			this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
		});
	}

	ngOnDestroy(): void {
		if (this.routerSubscription) {
			this.routerSubscription.unsubscribe();
		}
	}

	private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
		// Get the child routes
		const children: ActivatedRoute[] = route.children;

		// Return if there are no more children
		if (children.length === 0) {
			return breadcrumbs;
		}

		// Find the primary outlet route
		const primaryOutlet = children.find((child) => child.outlet === 'primary');

		if (!primaryOutlet) {
			return breadcrumbs;
		}

		// Get the route's URL segment
		const routeURL: string = primaryOutlet.snapshot.url.map((segment) => segment.path).join('/');

		// Append route URL to URL
		const currentUrl = routeURL ? `${url}/${routeURL}` : url;

		// Add breadcrumb if the route has data
		if (primaryOutlet.snapshot.data['title']) {
			const breadcrumb: Breadcrumb = {
				label: primaryOutlet.snapshot.data['title'],
				url: currentUrl,
			};
			breadcrumbs.push(breadcrumb);
		}

		// Continue with the next level
		return this.createBreadcrumbs(primaryOutlet, currentUrl, breadcrumbs);
	}
}
